module.exports = __webpack_public_path__ + "img/header-weddingRingsForestGreen.475f503.jpg";